import { calculateItemSalePrice } from "utils"

const calculateOrderItemSpecificationItems = (specificationItems) => (
  specificationItems.reduce((t, si) =>
    t += si.salePrice * (si.quantity - si.freeQuantity)
    , 0
  )
)

const calculateOrderItemsSubtotal = (orderItems) => (
  orderItems.reduce((to, item) =>
    to +=
    item.quantity *
    (
      calculateItemSalePrice(item, true) +
      calculateOrderItemSpecificationItems(item.specificationItems)
    )
    , 0
  )
)

export default calculateOrderItemsSubtotal